// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4eddb74b","667":"b198ff2d"}[chunkId] + ".chunk.js";
};